import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'filterHost'
})
export class FilterMeetingHostPipe implements PipeTransform {
  transform(items: any[], searchtext: string): any[] {
    if (!items) return [];
    if (!searchtext) return items;
    searchtext = searchtext.toLowerCase();
    return items.filter(it => {
      console.log('it ', it);
      if (it.user.emailId !== null)
        return it.user.emailId.toLowerCase().includes(searchtext);
    });
  }
}
